var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24.5289C6.63866 24.2849 5.95965 23.9146 5.39752 23.3525C3.75 21.705 3.75 19.0533 3.75 13.75C3.75 8.4467 3.75 5.79505 5.39752 4.14752C7.04505 2.5 9.6967 2.5 15 2.5C20.3033 2.5 22.955 2.5 24.6025 4.14752C26.25 5.79505 26.25 8.4467 26.25 13.75C26.25 19.0533 26.25 21.705 24.6025 23.3525C24.0404 23.9146 23.3613 24.2849 22.5 24.5289",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.241C14.4822 25.241 14.0656 25.6401 13.2322 26.4385C12.4243 27.2125 12.0203 27.5995 11.6797 27.478C11.6378 27.4631 11.5976 27.4434 11.5595 27.4194C11.25 27.2232 11.25 26.6389 11.25 25.4702V21.564C11.25 19.6482 11.25 18.6903 11.7992 18.0952C12.3483 17.5 13.2322 17.5 15 17.5C16.7678 17.5 17.6517 17.5 18.2008 18.0952C18.75 18.6903 18.75 19.6482 18.75 21.564V25.4702C18.75 26.6389 18.75 27.2232 18.4405 27.4194C18.4024 27.4434 18.3622 27.4631 18.3203 27.478C17.9797 27.5995 17.5757 27.2125 16.7678 26.4385C15.9344 25.6401 15.5178 25.241 15 25.241Z",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H20",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5H15",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/Vendor.1a6e8a1a4fcc5efa7d1b40a67156fe2b.svg";
export { ForwardRef as ReactComponent };